const fr = {
  nav: { home: "Accueil", lobby: "Jouer", wallet: "Portefeuille", profile: "Profil", board: "Classement", login: "Connexion", signup: "S'inscrire" },
  pwd: {
    title: "Changer mon mot de passe",
    forcedTitle: "Choisissez votre nouveau mot de passe",
    forcedText: "Votre mot de passe a été réinitialisé par notre équipe. Remplacez-le par un mot de passe que vous seul connaissez.",
    current: "Mot de passe actuel",
    temp: "Mot de passe provisoire reçu",
    new: "Nouveau mot de passe",
    confirm: "Confirmer le nouveau mot de passe",
    rule: "8 caractères minimum, avec au moins une lettre et un chiffre.",
    submit: "Enregistrer",
    mismatch: "Les deux mots de passe ne sont pas identiques.",
    done: "Mot de passe modifié.",
  },
  contact: {
    title: "Contact WhatsApp",
    text: "Une question, un souci de paiement ou de retrait ? Écrivez-nous.",
    cta: "Écrire sur WhatsApp",
    footer: "Contact WhatsApp :",
    message: "Bonjour BKMPLAY, j'ai une question :",
  },
  dames: {
    cad_blitz: "Blitz", cad_rapide: "Rapide", gain: "gain", toPlayer: "Invitation envoyée à {p}", openInvite: "Invitation par code", fromPlayer: "{p} vous invite",
    shareText: "Je te défie aux dames sur BKMPLAY ! Code : {code}", cancel: "Annuler", accept: "Accepter et miser {s}", decline: "Refuser",
    create: "Créer une partie privée", seekTitle: "Rechercher un adversaire", seekSub: "BKMPLAY vous met face au premier joueur qui choisit la même mise et la même cadence. Votre mise n'est bloquée qu'au moment où l'adversaire est trouvé.", seekBtn: "Rechercher un adversaire · {s}", seeking: "Recherche d'un adversaire…", seekCancel: "Arrêter", seekNone: "Aucun adversaire trouvé pour {s} ({c}).", seekAgain: "Continuer à chercher", seekQuit: "Quitter", orPrivate: "Ou invitez un ami", random: "Au hasard", pseudoPh: "Pseudo de l'adversaire (facultatif)", codePh: "Code (ex. DAB12C)",
    preview: "Pot {pot} · commission {com} · gain possible {gain}", createBtn: "Créer et miser {s}",
    stakeInfo: "Mise {s} · gain possible {gain}", oppOffline: "Adversaire déconnecté", startsIn: "Début dans {s} s", you: "vous",
    firstMove: "Premier coup : 30 s pour jouer, sinon la partie est annulée et remboursée", yourTurn: "À vous de jouer", oppTurn: "Au tour de l'adversaire",
    drawOffered: "Votre adversaire propose la nulle", acceptDraw: "Accepter la nulle", offerDraw: "Proposer nulle", resign: "Abandonner",
    resignConfirm: "Abandonner la partie ? Votre adversaire gagnera le pot.", cancelled: "Partie annulée – mises remboursées", youWin: "Vous avez gagné !", youLose: "Vous avez perdu",
    reason_no_pieces: "Toutes les pièces ont été prises", reason_no_moves: "Plus aucun coup possible", reason_resign: "Abandon", reason_time: "Temps écoulé",
    reason_agreement: "Nulle d'un commun accord", reason_repetition: "Nulle : position répétée 3 fois", reason_kings_25: "Nulle : 25 coups de dames",
    reason_first_move_timeout: "Premier coup non joué", backLobby: "Retour au lobby", getReady: "Préparez-vous…", history: "Mes dernières parties", notFound: "Partie introuvable.", vs: "contre {p}", histLost: "Perdue", histDraw: "Nulle", histCancelled: "Annulée", endSummary: "Pot {pot} · commission {com} · versé {pay} · mise {stake}",
    practiceTitle: "Dames · partie d'essai", practiceSub: "Sans mise : jouez les deux couleurs pour découvrir le damier.", practice: "Partie d'essai sans mise",
    white: "Blancs", black: "Noirs", toPlay: "Aux {c} de jouer", wins: "Victoire des {c}", draw: "Partie nulle",
    mustCapture: "Prise obligatoire", flip: "Retourner le damier", showCoords: "Afficher les numéros", hideCoords: "Masquer les numéros",
    startPos: "Position de départ", replay: "relecture", newGame: "Nouvelle partie", stakesSoon: "Les parties avec mise arrivent bientôt.",
  },
  ludo: {
    refundInfo: "Votre mise de {s} a été rendue sur votre portefeuille. Aucun argent perdu.",
    practice: "Partie gratuite (toutes les couleurs)", practiceTitle: "Ludo · partie gratuite", practiceSub: "Sans mise : vous jouez toutes les couleurs, à tour de rôle.", practiceTurn: "Au tour de {c}", practiceWin: "{c} gagne !", newGame: "Nouvelle partie",
    noMove: "aucun coup possible", threeSixes: "trois 6, tour perdu", c_red: "Rouge", c_green: "Vert", c_yellow: "Jaune", c_blue: "Bleu",
    rematch: "Revanche · même mise ({stake})", rematchAccept: "Accepter la revanche · {stake}", rematchOffer: "{name} propose une revanche · {n}/{total} prêt(s)",
    rematchWaiting: "Vous êtes prêt pour la revanche — en attente des autres joueurs", rematchStarted: "La revanche a commencé — la rejoindre", rematchClosed: "La revanche a été annulée.",
    privateRoom: "Créer un salon privé", joinCode: "Rejoindre avec un code", codePh: "Code du salon (ex. LAB12C)", go: "Rejoindre",
    roomTitle: "Salon privé de {name}", roomInfo: "{n} joueurs · {mode} · {stake} · {w} déjà présent(s)", roomJoin: "Rejoindre et miser {stake}",
    roomClosed: "Ce salon n'est plus ouvert.", roomCode: "Code du salon", roomHint: "Partagez ce code : la partie démarre dès que la table est complète.",
    shareText: "Rejoins ma table de Ludo sur BKMPLAY avec le code {code}", whatsapp: "Envoyer par WhatsApp", copy: "Copier le lien", copied: "Lien copié", cancelRoom: "Annuler le salon",
    playersQ: "Nombre de joueurs", modeQ: "Mode", stakeQ: "Mise (minimum 250 XAF)", quick: "Rapide", classic: "Classique", pieces: "pions",
    pot: "Pot", commission: "Commission", gain: "Gain possible", waiting: "joueur(s) en attente sur cette table", join: "Rechercher des joueurs",
    players: "joueurs", searching: "Recherche de joueurs…", leave: "Quitter la file (mise débloquée)", you: "vous", forfeit: "Abandon",
    home: "arrivés", roll: "Lancer", pick: "Touchez un pion qui clignote", playing: "joue…", youWin: "Vous gagnez", winner: "Gagnant :",
    timeLimit: "Temps maximum atteint : victoire au joueur le plus avancé.", verify: "Vérifier l'équité", again: "Rejouer", cancelled: "Annulée et remboursée",
    lost: "Perdu", history: "Mes parties de Ludo", seedHash: "Empreinte de la graine :", verifyNotReady: "Partie introuvable ou pas encore terminée.",
    vHash: "La graine correspond à l'empreinte publiée avant la partie", vDice: "Tous les lancers recalculés depuis la graine", vBoard: "Le plateau final rejoué coup par coup est identique",
  },
  sound: { on: "Activer le son", off: "Couper le son" },
  push: {
    enable: "M'avertir sur mon téléphone quand mon adversaire arrive", enabled: "Notifications activées sur cet appareil",
    denied: "Notifications bloquées : autorisez-les pour bkmplay.com dans les réglages du navigateur.",
    iosInstall: "Sur iPhone, installez d'abord l'application (Partager → Sur l'écran d'accueil) pour recevoir les notifications.",
    failed: "Impossible d'activer les notifications sur cet appareil.",
  },
  install: {
    tap: "Touchez", then: "puis", i3s: "Sur l'écran d'accueil", a3s: "Installer l'application",
    cta: "Installer l'application",
    short: "Installer",
    later: "Plus tard",
    banner: "Jouez plus vite : installez BKMPLAY sur votre écran d'accueil.",
    title: "Installer BKMPLAY sur votre téléphone",
    intro: "Gratuit, sans Play Store. L'icône BKMPLAY apparaît sur votre écran d'accueil et s'ouvre en plein écran.",
    android: "Android (Chrome)",
    a1: "Ouvrez ce site dans Chrome",
    a2: "Touchez le menu en haut à droite",
    a3: "Choisissez « Ajouter à l'écran d'accueil » ou « Installer l'application »",
    a4: "Confirmez avec « Installer »",
    iphone: "iPhone (Safari)",
    i1: "Ouvrez ce site dans Safari",
    i2: "Touchez le bouton Partager en bas",
    i3: "Choisissez « Sur l'écran d'accueil »",
    i4: "Touchez « Ajouter » en haut à droite",
  },
  landing: {
    overline: "Jeux en ligne avec mises · Cameroun",
    title1: "Dés, Ludo, Dames.",
    title2: "Affrontez de vrais joueurs,",
    title3: "remportez le pot.",
    subtitle: "BKMPLAY réunit trois jeux entre joueurs, avec un seul compte et un seul portefeuille. Rechargez par MTN Mobile Money ou Orange Money.",
    gamesTitle: "Nos jeux", play: "Jouer", soon: "Bientôt disponible", tryFree: "Essayer sans mise",
    diceName: "Dés", diceLine: "Lancez deux dés : le plus haut total remporte le pot.",
    ludoName: "Ludo", ludoLine: "Le Ludo classique à 2, 3 ou 4 joueurs, en mode rapide ou classique.",
    damesName: "Dames", damesLine: "Les dames internationales 10 × 10, en partie privée contre l'adversaire de votre choix.",
    cta: "Jouer maintenant",
    ctaWallet: "Mon portefeuille",
    rulesTitle: "Comment ça marche",
    rule1t: "Choisissez votre jeu et votre mise",
    rule1d: "Dés (2 à 6 joueurs), Ludo (2 à 4 joueurs) ou Dames (1 contre 1, sur invitation). Même mise pour tout le monde.",
    rule2t: "Jouez, le serveur arbitre",
    rule2d: "Dés tirés par le serveur et vérifiables, coups contrôlés, temps de jeu limité pour chacun.",
    rule3t: "Le gagnant remporte le pot",
    rule3d: "Le pot moins 15 % de commission est versé automatiquement. Partie annulée = mises remboursées.",
    exampleTitle: "Exemple",
    exampleLine: "4 joueurs × 500 XAF",
    pot: "Pot",
    commission: "Commission",
    winner: "Le gagnant reçoit",
    fairTitle: "Équité vérifiable",
    fairText: "Avant chaque partie, le serveur publie l'empreinte SHA-256 d'une graine secrète. À la fin, la graine est révélée : chacun peut recalculer tous les lancers.",
    mmTitle: "Mobile Money",
    mmText: "Recharge et retrait par Mobile Money, en XAF.",
    adult: "Réservé aux 18 ans et plus. Jouez de façon responsable.",
  },
  auth: {
    loginTitle: "Bon retour",
    loginSub: "Connectez-vous pour accéder à votre portefeuille.",
    signupTitle: "Créer un compte",
    signupSub: "Quelques infos et vous êtes prêt à jouer.",
    identifier: "E-mail, téléphone ou pseudo",
    password: "Mot de passe",
    passwordHint: "8 caractères minimum, avec lettres et chiffres",
    refCode: "Code de parrainage (facultatif)", refHint: "Le code de l'ami qui vous a invité.",
    confirmPassword: "Confirmer le mot de passe", passwordMismatch: "Les deux mots de passe ne sont pas identiques.",
    showPassword: "Afficher le mot de passe", hidePassword: "Masquer le mot de passe",
    pseudo: "Pseudo",
    pseudoHint: "3 à 20 caractères : lettres, chiffres, _ ou -",
    useEmail: "E-mail",
    usePhone: "Téléphone",
    email: "Adresse e-mail",
    phone: "Numéro de téléphone",
    birthDate: "Date de naissance",
    confirmAdult: "Je confirme avoir 18 ans ou plus",
    acceptTerms: "J'accepte les conditions générales et la politique de confidentialité",
    submitLogin: "Se connecter",
    forgot: "Mot de passe oublié ?",
    forgotText: "Écrivez à notre équipe sur WhatsApp en indiquant votre pseudo ou votre numéro. Après vérification, nous vous enverrons un mot de passe provisoire à changer dès la connexion.",
    forgotCta: "Écrire sur WhatsApp",
    forgotMsg: "Bonjour BKMPLAY, j'ai oublié mon mot de passe. Mon pseudo ou numéro :",
    submitSignup: "Créer mon compte",
    noAccount: "Pas encore de compte ?",
    haveAccount: "Déjà un compte ?",
    welcome: "Bienvenue",
    logout: "Se déconnecter",
  },
  wallet: {
    title: "Portefeuille",
    withdrawable: "Retirable maintenant", toWager: "Encore {a} à jouer avant de pouvoir tout retirer (chaque recharge doit être misée une fois en partie).",
    available: "Solde disponible",
    locked: "Solde bloqué",
    lockedHint: "Mises en cours",
    total: "Total",
    deposit: "Recharger",
    withdraw: "Retirer",
    withdrawSoon: "Les retraits arrivent à l'étape 4",
    history: "Historique",
    payments: "Recharges",
    empty: "Aucune opération pour l'instant.",
    emptyPayments: "Aucune recharge pour l'instant.",
    all: "Tout",
    notReady: "Les paiements Mobile Money ne sont pas encore configurés.",
  },
  types: {
    deposit: "Dépôt", stake_lock: "Mise bloquée", stake_unlock: "Mise débloquée", stake_lost: "Mise perdue",
    win: "Gain", commission: "Commission", withdrawal: "Retrait", withdrawal_refund: "Remboursement retrait",
    refund: "Remboursement", admin_adjustment: "Ajustement",
  },
  deposit: {
    title: "Recharger mon portefeuille",
    opAuto: "L'opérateur est reconnu automatiquement à partir du numéro.", opDetected: "Numéro {op} reconnu.",
    operator: "Opérateur",
    phone: "Numéro Mobile Money",
    amount: "Montant (XAF)",
    range: "Entre {min} et {max} XAF",
    submit: "Demander le paiement",
    pendingTitle: "Validez sur votre téléphone",
    pendingText: "Une demande de paiement a été envoyée au {phone}. Confirmez-la avec votre code secret.",
    ussd: "Si rien n'apparaît, composez",
    verify: "Vérifier le paiement",
    autoCheck: "Vérification automatique en cours…",
    successTitle: "Paiement réussi",
    successText: "{amount} ont été ajoutés à votre solde disponible.",
    failedTitle: "Paiement échoué",
    failedText: "Le paiement n'a pas abouti. Aucun montant n'a été débité de votre portefeuille.",
    reviewTitle: "Paiement en vérification",
    reviewText: "Le montant reçu ne correspond pas. Notre équipe vérifie ce paiement.",
    close: "Fermer",
    again: "Nouvelle recharge",
  },
  status: { PENDING: "En attente", SUCCESSFUL: "Réussi", FAILED: "Échoué", EXPIRED: "Expiré", REVIEW: "En vérification", INITIATING: "Initialisation", AWAITING_APPROVAL: "Validation manuelle", FAILING: "Échoué" },
  withdraw: {
    title: "Retirer mes gains",
    submit: "Demander le retrait",
    s_PENDING: "Retrait en cours",
    s_INITIATING: "Retrait en cours",
    s_SUCCESSFUL: "Retrait effectué",
    s_FAILED: "Retrait échoué – montant remboursé",
    s_FAILING: "Retrait échoué – remboursement",
    s_AWAITING_APPROVAL: "Demande envoyée : en attente de validation par notre équipe. Le montant est réservé et vous sera rendu si le retrait est refusé.",
    s_REVIEW: "Retrait en vérification",
  },
  resp: { title: "Mon compte", kyc_none: "Non renseignée (requise avant le premier retrait)", kyc_pending: "Informations reçues, à vérifier", kyc_approved: "Identité vérifiée", kyc_rejected: "Refusée", fullName: "Nom complet", cni: "Carte nationale d'identité", passport: "Passeport", permit: "Permis / titre de séjour", docNumber: "Numéro de la pièce", region: "Votre région", fileHint: "Photos nettes et lisibles. Les photos du téléphone sont automatiquement allégées.", front: "Recto (face avant)", back: "Verso (face arrière)", passportPage: "Page avec votre photo", choosePhoto: "Prendre ou choisir une photo", changePhoto: "Changer la photo", missingFront: "Ajoutez la photo du recto.", missingBack: "Ajoutez aussi la photo du verso.", sending: "Envoi…", kycSubmit: "Envoyer mes informations", kycSent: "Informations enregistrées. Vous pouvez demander votre retrait.", kycNote: "Ces informations seront vérifiées. Lors de votre premier retrait, notre équipe vous contactera sur WhatsApp pour recevoir la photo de votre pièce (recto et verso). Aucune photo n'est demandée ici.", kycPendingNote: "Lors de votre premier retrait, notre équipe vous contactera sur WhatsApp pour vérifier votre pièce.", current: "Limites actuelles", daily: "Dépôt / jour", weekly: "Dépôt / semaine", limitHint: "Vous pouvez baisser une limite à tout moment ; pour l'augmenter, demandez au support.", save: "Enregistrer les limites", saved: "Limites enregistrées", exclude: "Auto-exclusion temporaire (jeu et dépôts bloqués, irréversible pendant la durée) :", excludedUntil: "Auto-exclu jusqu'au {date}", excludeConfirm: "Bloquer le jeu et les dépôts pendant {days} jour(s) ? Impossible d'annuler.", days: "{n} j" },
  history: { title: "Historique des parties", games: "Parties", wins: "Victoires", won: "Total gagné", net: "Bilan net", empty: "Aucune partie terminée pour l'instant.", r_won: "Gagnée", r_lost: "Perdue", r_refunded: "Remboursée" },
  board: { dice: "Dés", ludo: "Ludo", dames: "Dames", title: "Classement", week: "Semaine", month: "Mois", all: "Tout", wins: "{w} V / {g}", draws: "{d} N", empty: "Pas encore de parties sur cette période.", note: "Classé par bilan net (gains − mises)." },
  room: { whatsapp: "Envoyer par WhatsApp", joinTitle: "Rejoindre un salon privé", info: "Salon de {name} · {n} joueurs · {stake} · {w} déjà présent(s)", closed: "Ce salon n'est plus ouvert.", join: "Rejoindre et miser {stake}", code: "Code du salon", share: "Partager l'invitation", shareText: "Rejoins ma table BKMPLAY avec le code {code}", copied: "Lien copié", cancel: "Annuler le salon" },
  inbox: { title: "Messages", sub: "Vos avis de dépôt, de retrait, d'identité et les messages de BKMPLAY. Ils s'effacent automatiquement après {d} jours.", empty: "Aucun message pour le moment.",
    k: { announcement: "Annonce BKMPLAY",
      withdraw_requested: { t: "Demande de retrait reçue", b: "Votre demande de retrait de {a} vers le numéro …{p} est enregistrée. Elle sera vérifiée par notre équipe." },
      withdraw_approved: { t: "Retrait validé", b: "Votre retrait de {a} a été validé. L'envoi vers votre Mobile Money est en cours." },
      withdraw_sent: { t: "Retrait envoyé", b: "{a} ont été envoyés sur votre numéro …{p}." },
      withdraw_rejected: { t: "Retrait refusé", b: "Votre retrait de {a} a été refusé : {r}. Le montant a été remis sur votre solde." },
      withdraw_failed: { t: "Retrait échoué", b: "L'envoi de votre retrait de {a} n'a pas abouti. Le montant a été remis sur votre solde." },
      deposit_ok: { t: "Dépôt reçu", b: "{a} ont été ajoutés à votre solde. Bon jeu !" },
      deposit_failed: { t: "Dépôt échoué", b: "Votre dépôt de {a} n'a pas abouti. Aucun montant n'a été prélevé sur votre solde de jeu." },
      kyc_approved: { t: "Identité confirmée", b: "Votre identité est confirmée. Vos retraits peuvent maintenant être envoyés." },
      kyc_rejected: { t: "Identité refusée", b: "Votre déclaration d'identité a été refusée : {r}. Vous pouvez la refaire depuis Mon compte." } } },
  ref: { title: "Parrainage", pitch: "Invitez vos amis : à chaque partie avec mise qu'ils terminent, vous recevez {p} % de la commission prise sur leur mise.", code: "Votre code :", copied: "Lien copié", invite: "Inviter sur WhatsApp", waText: "Rejoins-moi sur BKMPLAY (Dés, Ludo, Dames) avec mon lien :", filleuls: "Amis inscrits", active: "Actifs ce mois", month: "Gagné ce mois", balance: "À transférer", transfer: "Transférer {a} vers mon solde", minTransfer: "Transfert possible dès {m}", transferred: "{a} ajoutés à votre solde", rules: "Lire le règlement du parrainage", needKyc: "Faites confirmer votre identité (Mon compte) pour obtenir votre lien de parrainage.", blocked: "Votre parrainage est suspendu. Contactez le support.", account: "Compte parrainage", accountSub: "Vos gains de parrainage sont gardés ici, à part. Ils ne servent pas à jouer ni à retirer : vous pouvez seulement les transférer vers votre solde de jeu." },
  chat: { title: "Chat de la partie", placeholder: "Votre message…", empty: "Aucun message pour l'instant. Dites bonjour !", mute: "Masquer ce joueur", unmute: "Réafficher les joueurs masqués", report: "Signaler", reportReason: "Pourquoi signalez-vous ce message ? (facultatif)", reported: "Message signalé à l'équipe.",
    q_gg: "Bien joué !", q_luck: "Bonne chance !", q_nice: "Joli coup !", q_oops: "Oups !", q_hurry: "On accélère ?", q_thanks: "Merci !", q_again: "On rejoue ?", q_wow: "Waouh !" },
  share: { btn: "Défier un ami sur WhatsApp", text: "Je viens de jouer une partie gratuite de {game} sur BKMPLAY : {result} Viens me défier, c'est gratuit :", dice: "Dés", dames: "Dames" },
  demo: {
    practice: "Partie gratuite (lancez pour chaque joueur)", practiceTitle: "Dés · partie gratuite", practiceSub: "Sans mise : vous lancez les dés pour chaque joueur, le plus haut total gagne.", seat: "Joueur {n}", rollFor: "Lancer pour {p}", tieAgain: "Égalité : {p} relancent", practiceWin: "{p} gagne !",
    cardTitle: "Partie de découverte offerte",
    cardText: "Essayez le jeu gratuitement contre 3 joueurs virtuels, avant de recharger.",
    cardCta: "Jouer gratuitement",
    title: "Votre partie offerte",
    text: "Vous jouez contre 3 joueurs virtuels, avec les mêmes dés et les mêmes règles que les vraies parties : 2 dés chacun, le total le plus haut gagne, les ex æquo relancent.",
    noMoney: "Mode démo : aucun argent réel, rien n'est lié à votre portefeuille. Une seule partie offerte par compte.",
    start: "Commencer la partie",
    used: "Vous avez déjà joué votre partie offerte. Prêt pour une vraie partie ?",
    tableTitle: "Partie démo",
    virtualPot: "Pot virtuel",
    tie: "Égalité ! Les ex æquo relancent",
    roll: "Lancer les dés",
    rolling: "lance les dés…",
    won: "Bravo, vous gagnez",
    virtual: "(virtuels)",
    lost: "Pas cette fois ! Vous avez maintenant compris le jeu.",
    after: "Dans une vraie partie, le pot moins 15 % de commission revient au gagnant.",
    topup: "Recharger mon portefeuille",
    realGame: "Jouer une vraie partie",
    seed: "Graine de la partie :",
    guestUsed: "Vous avez déjà essayé la partie démo. Créez votre compte pour jouer pour de vrai.",
    signup: "Créer mon compte",
    tryFree: "Essayer gratuitement",
  },
  lobby: {
    overline: "Étape 3",
    title: "La table de jeu arrive bientôt",
    text: "Matchmaking en direct, files par nombre de joueurs et par mise, lancers en temps réel. Votre compte et votre portefeuille sont déjà prêts.",
    stakes: "Mises prévues",
    players: "Joueurs par table",
    goWallet: "Recharger mon portefeuille",
    title2: "Choisissez votre table",
    playersLabel: "Nombre de joueurs",
    stakeLabel: "Mise (XAF)",
    custom: "Ou saisissez votre mise",
    customHint: "Montant libre entre {min} et {max} XAF",
    pot: "Pot",
    commission: "Commission",
    gain: "Gain possible",
    search: "Rechercher des joueurs",
    waitingNow: "En attente en ce moment",
    noneWaiting: "Personne en attente pour l'instant. Lancez une recherche !",
    waitingFmt: "{n} joueurs · {stake}",
    privateRoom: "Créer un salon privé",
    joinCode: "Rejoindre avec un code",
    soon: "Salons privés : étape 4",
    balance: "Solde disponible",
    insufficient: "Solde insuffisant pour cette mise.",
    topup: "Recharger",
    online: "{n} connectés",
  },
  queue: {
    title: "Recherche de joueurs",
    subtitle: "{n} joueurs · {stake}",
    counter: "{a}/{b} en attente",
    elapsed: "Temps d'attente",
    locked: "Mise bloquée",
    leave: "Quitter la file",
    promptTitle: "Toujours là ?",
    promptText: "Aucune table complète pour l'instant. Continuer à attendre ? Sans réponse sous 30 s, vous quittez la file et votre mise est débloquée.",
    continue: "Continuer",
    quit: "Quitter",
    leftOk: "Vous avez quitté la file. Mise débloquée.",
    left_timeout: "Délai dépassé : vous avez quitté la file, mise débloquée.",
    left_disconnected: "Déconnexion : vous avez quitté la file, mise débloquée.",
    left_left: "Vous avez quitté la file.",
    left_room_cancelled: "Le salon a été annulé par son créateur. Mise débloquée.",
  },
  game: {
    title: "Table · {n} joueurs",
    startsIn: "La partie commence dans",
    finalReveal: "Dernier lancer… résultat dans un instant",
    waitingFor: "En attente de {names}… La partie commencera dès son arrivée (90 s max).",
    roll: "Lancer",
    turnOf: "Au tour de {name}",
    you: "vous",
    auto: "auto",
    order: "Ordre de passage",
    round0: "Premier lancer",
    reroll: "Relance n°{n} (égalité)",
    winnerTitle: "Victoire !",
    splitTitle: "Égalité : pot partagé",
    lostTitle: "Partie terminée",
    youWon: "Vous gagnez {amount}",
    winnerIs: "{name} remporte {amount}",
    lostText: "Votre mise de {amount} est perdue.",
    verify: "Vérifier l'équité",
    again: "Rejouer",
    cancelled: "Partie annulée",
    cancelledText: "Toutes les mises ont été remboursées.",
    settling: "Règlement en cours…",
    hash: "Empreinte",
    seed: "Graine révélée",
  },
  profile: {
    title: "Profil",
    memberSince: "Membre depuis",
    birth: "Date de naissance",
    kyc: "Vérification d'identité",
    kycNone: "Non vérifiée (requise avant le premier retrait)",
    language: "Langue",
    legal: "Informations légales",
  },
  legal: { terms: "Conditions générales", rules: "Règles du jeu", privacy: "Confidentialité", responsible: "Jeu responsable", back: "Retour" },
  verify: {
    title: "Vérifier une partie",
    intro: "Avant chaque partie, le serveur publie l'empreinte SHA-256 de sa graine secrète. Une fois la partie terminée, la graine est révélée : collez-la ici et votre navigateur recalcule lui-même l'ordre de passage et chaque lancer (HMAC-SHA256).",
    demo: "Essayer avec une partie de démonstration",
    gameId: "Identifiant de la partie",
    seedHash: "Empreinte publiée avant la partie (SHA-256)",
    seed: "Graine révélée",
    players: "Identifiants des joueurs (séparés par des virgules)",
    submit: "Recalculer la partie",
    local: "Le calcul est fait dans votre navigateur, sans le serveur.",
    hashOk: "La graine correspond à l'empreinte publiée",
    hashBad: "La graine NE correspond PAS à l'empreinte publiée",
    serverOk: "Le résultat recalculé est identique à celui du serveur",
    serverBad: "Le résultat recalculé diffère de celui du serveur",
    order: "Ordre de passage :",
    winner: "Gagnant :",
    hashNone: "Aucune empreinte saisie : la graine n'a pas été comparée",
    unsupported: "Votre navigateur ne permet pas ce calcul (connexion sécurisée requise).",
    round0: "Premier lancer",
    reroll: "Relance n°{n}",
    missing: "Remplissez l'identifiant, la graine et au moins 2 joueurs.",
    seedHidden: "Partie en cours : la graine sera révélée à la fin.",
    cta: "Vérifier une partie",
  },
  common: { loading: "Chargement…", retry: "Réessayer", today: "Aujourd'hui", back: "Retour" },
  errors: {
    chat_disabled: "Le chat est désactivé pour le moment.", referral_below_min: "Montant insuffisant pour un transfert.", referral_blocked: "Parrainage suspendu.", rate_limited: "Trop de messages, patientez un instant.", invalid_message: "Message invalide.", own_message: "Vous ne pouvez pas signaler votre propre message.",
    invalid_credentials: "Identifiant ou mot de passe incorrect.",
    too_many_attempts: "Trop de tentatives. Réessayez dans 15 minutes.",
    too_many_requests: "Trop de requêtes. Patientez un instant.",
    must_be_adult: "Vous devez avoir 18 ans ou plus.",
    must_confirm_adult_and_terms: "Veuillez cocher les deux confirmations.",
    email_or_phone_required: "Indiquez un e-mail ou un téléphone.",
    invalid_email: "Adresse e-mail invalide.",
    invalid_phone: "Numéro invalide. Format : 6XXXXXXXX ou 2376XXXXXXXX.",
    unsupported_operator: "Ce numéro n'est ni MTN (650-654, 670-683) ni Orange (655-659, 686-699).",
    operator_mismatch: "Ce numéro ne correspond pas à l'opérateur choisi.",
    pseudo_taken: "Ce pseudo est déjà utilisé.",
    invalid_ref_code: "Code de parrainage inconnu ou inactif. Vérifiez-le ou laissez le champ vide.",
    email_taken: "Cet e-mail est déjà utilisé.",
    phone_taken: "Ce numéro est déjà utilisé.",
    validation_error: "Vérifiez les champs du formulaire.",
    amount_out_of_range: "Montant hors limites.",
    campay_not_configured: "Les paiements ne sont pas encore configurés.",
    campay_error: "Le service de paiement a refusé la demande.",
    too_many_pending_payments: "Vous avez déjà 3 paiements en attente.",
    account_suspended: "Compte suspendu.",
    network_error: "Connexion impossible. Vérifiez votre réseau.",
    invalid_stake: "Mise invalide (minimum 25 XAF, nombre entier).",
    invalid_player_count: "Nombre de joueurs invalide.",
    insufficient_funds: "Solde disponible insuffisant.",
    already_in_queue: "Vous êtes déjà dans une file d'attente.",
    already_in_game: "Vous avez déjà une partie en cours.",
    opponent_unavailable: "L'adversaire trouvé n'avait plus assez de solde. Relancez la recherche.",
    maintenance: "Maintenance : nouvelles parties temporairement bloquées.",
    not_your_turn: "Ce n'est pas votre tour.",
    game_not_in_progress: "La partie n'est pas en cours.",
    stale_game_state: "Lancer déjà effectué.",
    not_in_queue: "Vous n'êtes plus dans la file.",
    game_not_found: "Partie introuvable.",
    kyc_required: "Vérification d'identité requise avant le premier retrait (Profil → Mon compte).",
    self_excluded: "Auto-exclusion en cours : jeu et dépôts bloqués.",
    deposit_daily_limit_reached: "Limite de dépôt journalière atteinte.",
    deposit_weekly_limit_reached: "Limite de dépôt hebdomadaire atteinte.",
    limit_increase_needs_support: "Pour augmenter une limite, contactez le support.",
    kyc_already_submitted: "Pièce déjà envoyée.", invalid_region: "Choisissez votre région.",
    image_too_large: "Image trop lourde (2 Mo max).",
    back_side_required: "Ajoutez aussi la photo du verso.",
    wrong_current_password: "Mot de passe actuel incorrect.",
    invalid_mode: "Mode de jeu indisponible.", not_your_turn: "Ce n'est pas votre tour.", illegal_piece: "Ce pion ne peut pas bouger.",
    game_not_active: "La partie est terminée.", already_in_queue: "Vous êtes déjà dans une file.", conflict: "Réessayez.",
    same_password: "Choisissez un mot de passe différent de l'actuel.",
    unreadable_image: "Photo illisible : choisissez une photo JPG ou PNG.",
    invalid_image: "Image invalide (JPG, PNG ou WEBP).",
    illegal_move: "Coup non autorisé.", invite_not_found: "Invitation introuvable ou déjà utilisée.", invite_expired: "Invitation expirée.",
    invite_not_for_you: "Cette invitation est destinée à un autre joueur.", cannot_invite_self: "Vous ne pouvez pas vous inviter vous-même.",
    player_not_found: "Aucun joueur avec ce pseudo.", stake_not_allowed: "Mise non autorisée.", not_your_turn: "Ce n'est pas votre tour.", draw_offer_limit: "Plus de proposition de nulle possible.", room_not_found: "Salon introuvable ou fermé.", waiting_players: "La partie attend encore un joueur.", room_restricted: "Ce salon est réservé aux joueurs de la partie précédente.", rematch_unavailable: "La revanche n'est possible qu'après une partie en salon privé.",
    daily_withdraw_limit: "Plafond journalier de retrait atteint.",
    withdraw_in_progress: "Une demande de retrait est déjà en cours, patientez un instant.",
    wager_required: "Chaque recharge doit être misée une fois en partie avant d'être retirée. Encore {r} à jouer ; vous pouvez retirer jusqu'à {w} maintenant.",
    unknown_error: "Une erreur est survenue.",
  },
};

const en = {
  nav: { home: "Home", lobby: "Play", wallet: "Wallet", profile: "Profile", board: "Ranking", login: "Log in", signup: "Sign up" },
  pwd: {
    title: "Change my password",
    forcedTitle: "Choose your new password",
    forcedText: "Your password was reset by our team. Replace it with a password only you know.",
    current: "Current password",
    temp: "Temporary password received",
    new: "New password",
    confirm: "Confirm new password",
    rule: "At least 8 characters, with at least one letter and one digit.",
    submit: "Save",
    mismatch: "The two passwords do not match.",
    done: "Password changed.",
  },
  contact: {
    title: "WhatsApp contact",
    text: "A question, a payment or withdrawal issue? Message us.",
    cta: "Message on WhatsApp",
    footer: "WhatsApp contact:",
    message: "Hello BKMPLAY, I have a question:",
  },
  dames: {
    cad_blitz: "Blitz", cad_rapide: "Rapid", gain: "win", toPlayer: "Invitation sent to {p}", openInvite: "Invitation by code", fromPlayer: "{p} invites you",
    shareText: "I challenge you to draughts on BKMPLAY! Code: {code}", cancel: "Cancel", accept: "Accept and stake {s}", decline: "Decline",
    create: "Create a private game", seekTitle: "Find an opponent", seekSub: "BKMPLAY pairs you with the first player who picks the same stake and time control. Your stake is only locked once an opponent is found.", seekBtn: "Find an opponent · {s}", seeking: "Looking for an opponent…", seekCancel: "Stop", seekNone: "No opponent found for {s} ({c}).", seekAgain: "Keep searching", seekQuit: "Quit", orPrivate: "Or invite a friend", random: "Random", pseudoPh: "Opponent's username (optional)", codePh: "Code (e.g. DAB12C)",
    preview: "Pot {pot} · commission {com} · possible win {gain}", createBtn: "Create and stake {s}",
    stakeInfo: "Stake {s} · possible win {gain}", oppOffline: "Opponent disconnected", startsIn: "Starts in {s} s", you: "you",
    firstMove: "First move: 30 s to play, otherwise the game is cancelled and refunded", yourTurn: "Your move", oppTurn: "Opponent's move",
    drawOffered: "Your opponent offers a draw", acceptDraw: "Accept draw", offerDraw: "Offer draw", resign: "Resign",
    resignConfirm: "Resign the game? Your opponent will win the pot.", cancelled: "Game cancelled – stakes refunded", youWin: "You won!", youLose: "You lost",
    reason_no_pieces: "All pieces captured", reason_no_moves: "No move left", reason_resign: "Resignation", reason_time: "Time out",
    reason_agreement: "Draw by agreement", reason_repetition: "Draw: position repeated 3 times", reason_kings_25: "Draw: 25 king moves",
    reason_first_move_timeout: "First move not played", backLobby: "Back to lobby", getReady: "Get ready…", history: "My recent games", notFound: "Game not found.", vs: "vs {p}", histLost: "Lost", histDraw: "Draw", histCancelled: "Cancelled", endSummary: "Pot {pot} · commission {com} · paid {pay} · stake {stake}",
    practiceTitle: "Draughts · practice game", practiceSub: "No stake: play both colours to try the board.", practice: "Practice game, no stake",
    white: "White", black: "Black", toPlay: "{c} to play", wins: "{c} wins", draw: "Draw",
    mustCapture: "Capture is mandatory", flip: "Flip the board", showCoords: "Show numbers", hideCoords: "Hide numbers",
    startPos: "Starting position", replay: "replay", newGame: "New game", stakesSoon: "Games with stakes are coming soon.",
  },
  ludo: {
    refundInfo: "Your {s} stake has been returned to your wallet. No money lost.",
    practice: "Free game (all colours)", practiceTitle: "Ludo · free game", practiceSub: "No stake: you play every colour in turn.", practiceTurn: "{c} to play", practiceWin: "{c} wins!", newGame: "New game",
    noMove: "no move possible", threeSixes: "three 6s, turn lost", c_red: "Red", c_green: "Green", c_yellow: "Yellow", c_blue: "Blue",
    rematch: "Rematch · same stake ({stake})", rematchAccept: "Accept the rematch · {stake}", rematchOffer: "{name} wants a rematch · {n}/{total} ready",
    rematchWaiting: "You are ready for the rematch — waiting for the other players", rematchStarted: "The rematch has started — join it", rematchClosed: "The rematch was cancelled.",
    privateRoom: "Create a private room", joinCode: "Join with a code", codePh: "Room code (e.g. LAB12C)", go: "Join",
    roomTitle: "{name}'s private room", roomInfo: "{n} players · {mode} · {stake} · {w} already in", roomJoin: "Join and stake {stake}",
    roomClosed: "This room is no longer open.", roomCode: "Room code", roomHint: "Share this code: the game starts as soon as the table is full.",
    shareText: "Join my Ludo table on BKMPLAY with code {code}", whatsapp: "Send via WhatsApp", copy: "Copy link", copied: "Link copied", cancelRoom: "Cancel the room",
    playersQ: "Number of players", modeQ: "Mode", stakeQ: "Stake (minimum 250 XAF)", quick: "Quick", classic: "Classic", pieces: "pieces",
    pot: "Pot", commission: "Commission", gain: "Possible win", waiting: "player(s) waiting at this table", join: "Find players",
    players: "players", searching: "Looking for players…", leave: "Leave the queue (stake released)", you: "you", forfeit: "Forfeit",
    home: "home", roll: "Roll", pick: "Tap a blinking piece", playing: "is playing…", youWin: "You win", winner: "Winner:",
    timeLimit: "Time limit reached: the most advanced player wins.", verify: "Verify fairness", again: "Play again", cancelled: "Cancelled and refunded",
    lost: "Lost", history: "My Ludo games", seedHash: "Seed fingerprint:", verifyNotReady: "Game not found or not finished yet.",
    vHash: "The seed matches the fingerprint published before the game", vDice: "Every roll recomputed from the seed", vBoard: "The final board replayed move by move is identical",
  },
  sound: { on: "Turn sound on", off: "Mute sound" },
  push: {
    enable: "Notify me on my phone when my opponent arrives", enabled: "Notifications enabled on this device",
    denied: "Notifications are blocked: allow them for bkmplay.com in your browser settings.",
    iosInstall: "On iPhone, first install the app (Share → Add to Home Screen) to receive notifications.",
    failed: "Could not enable notifications on this device.",
  },
  install: {
    tap: "Tap", then: "then", i3s: "Add to Home Screen", a3s: "Install app",
    cta: "Install the app",
    short: "Install",
    later: "Later",
    banner: "Play faster: add BKMPLAY to your home screen.",
    title: "Install BKMPLAY on your phone",
    intro: "Free, no Play Store needed. The BKMPLAY icon appears on your home screen and opens full screen.",
    android: "Android (Chrome)",
    a1: "Open this site in Chrome",
    a2: "Tap the menu at the top right",
    a3: "Choose \"Add to Home screen\" or \"Install app\"",
    a4: "Confirm with \"Install\"",
    iphone: "iPhone (Safari)",
    i1: "Open this site in Safari",
    i2: "Tap the Share button at the bottom",
    i3: "Choose \"Add to Home Screen\"",
    i4: "Tap \"Add\" at the top right",
  },
  landing: {
    overline: "Online games with stakes · Cameroon",
    title1: "Dice, Ludo, Draughts.",
    title2: "Face real players,",
    title3: "take the pot.",
    subtitle: "BKMPLAY brings three player-versus-player games together, with one account and one wallet. Top up with MTN Mobile Money or Orange Money.",
    gamesTitle: "Our games", play: "Play", soon: "Coming soon", tryFree: "Try without stake",
    diceName: "Dice", diceLine: "Roll two dice: the highest total takes the pot.",
    ludoName: "Ludo", ludoLine: "Classic Ludo for 2, 3 or 4 players, quick or classic mode.",
    damesName: "Draughts", damesLine: "International 10 × 10 draughts, in a private game against the opponent of your choice.",
    cta: "Play now",
    ctaWallet: "My wallet",
    rulesTitle: "How it works",
    rule1t: "Pick your game and stake",
    rule1d: "Dice (2 to 6 players), Ludo (2 to 4 players) or Draughts (1 vs 1, by invitation). Same stake for everyone.",
    rule2t: "Play, the server referees",
    rule2d: "Verifiable server-drawn dice, every move checked, limited playing time for each player.",
    rule3t: "The winner takes the pot",
    rule3d: "The pot minus 15% commission is paid automatically. Cancelled game = stakes refunded.",
    exampleTitle: "Example",
    exampleLine: "4 players × 500 XAF",
    pot: "Pot",
    commission: "Commission",
    winner: "Winner receives",
    fairTitle: "Provably fair",
    fairText: "Before each game the server publishes the SHA-256 hash of a secret seed. At the end the seed is revealed so anyone can recompute every roll.",
    mmTitle: "Mobile Money",
    mmText: "Deposits and withdrawals by Mobile Money, in XAF.",
    adult: "18+ only. Please play responsibly.",
  },
  auth: {
    loginTitle: "Welcome back",
    loginSub: "Log in to access your wallet.",
    signupTitle: "Create an account",
    signupSub: "A few details and you're ready to play.",
    identifier: "Email, phone or username",
    password: "Password",
    passwordHint: "At least 8 characters, letters and digits",
    refCode: "Referral code (optional)", refHint: "The code of the friend who invited you.",
    confirmPassword: "Confirm password", passwordMismatch: "The two passwords do not match.",
    showPassword: "Show password", hidePassword: "Hide password",
    pseudo: "Username",
    pseudoHint: "3 to 20 characters: letters, digits, _ or -",
    useEmail: "Email",
    usePhone: "Phone",
    email: "Email address",
    phone: "Phone number",
    birthDate: "Date of birth",
    confirmAdult: "I confirm I am 18 or older",
    acceptTerms: "I accept the terms and the privacy policy",
    submitLogin: "Log in",
    forgot: "Forgot your password?",
    forgotText: "Message our team on WhatsApp with your username or phone number. After checking, we will send you a temporary password to change as soon as you log in.",
    forgotCta: "Message on WhatsApp",
    forgotMsg: "Hello BKMPLAY, I forgot my password. My username or number:",
    submitSignup: "Create my account",
    noAccount: "No account yet?",
    haveAccount: "Already have an account?",
    welcome: "Welcome",
    logout: "Log out",
  },
  wallet: {
    title: "Wallet",
    withdrawable: "Withdrawable now", toWager: "{a} still to play before you can withdraw everything (each top-up must be staked once in a game).",
    available: "Available balance",
    locked: "Locked balance",
    lockedHint: "Stakes in play",
    total: "Total",
    deposit: "Top up",
    withdraw: "Withdraw",
    withdrawSoon: "Withdrawals arrive in step 4",
    history: "History",
    payments: "Top-ups",
    empty: "No transactions yet.",
    emptyPayments: "No top-ups yet.",
    all: "All",
    notReady: "Mobile Money payments are not configured yet.",
  },
  types: {
    deposit: "Deposit", stake_lock: "Stake locked", stake_unlock: "Stake released", stake_lost: "Stake lost",
    win: "Win", commission: "Commission", withdrawal: "Withdrawal", withdrawal_refund: "Withdrawal refund",
    refund: "Refund", admin_adjustment: "Adjustment",
  },
  deposit: {
    title: "Top up my wallet",
    opAuto: "The operator is detected automatically from the number.", opDetected: "{op} number detected.",
    operator: "Operator",
    phone: "Mobile Money number",
    amount: "Amount (XAF)",
    range: "Between {min} and {max} XAF",
    submit: "Request payment",
    pendingTitle: "Confirm on your phone",
    pendingText: "A payment request was sent to {phone}. Confirm it with your PIN.",
    ussd: "If nothing shows up, dial",
    verify: "Check payment",
    autoCheck: "Checking automatically…",
    successTitle: "Payment successful",
    successText: "{amount} added to your available balance.",
    failedTitle: "Payment failed",
    failedText: "The payment did not go through. Nothing was charged to your wallet.",
    reviewTitle: "Payment under review",
    reviewText: "The amount received does not match. Our team is reviewing this payment.",
    close: "Close",
    again: "New top-up",
  },
  status: { PENDING: "Pending", SUCCESSFUL: "Successful", FAILED: "Failed", EXPIRED: "Expired", REVIEW: "Under review", INITIATING: "Starting", AWAITING_APPROVAL: "Manual approval", FAILING: "Failed" },
  withdraw: {
    title: "Withdraw my winnings",
    submit: "Request withdrawal",
    s_PENDING: "Withdrawal in progress",
    s_INITIATING: "Withdrawal in progress",
    s_SUCCESSFUL: "Withdrawal completed",
    s_FAILED: "Withdrawal failed – amount refunded",
    s_FAILING: "Withdrawal failed – refunding",
    s_AWAITING_APPROVAL: "Request sent: awaiting approval by our team. The amount is reserved and returned to you if the withdrawal is rejected.",
    s_REVIEW: "Withdrawal under review",
  },
  resp: { title: "My account", kyc_none: "Not provided (required before first withdrawal)", kyc_pending: "Details received, to be verified", kyc_approved: "Identity verified", kyc_rejected: "Rejected", fullName: "Full name", cni: "National ID card", passport: "Passport", permit: "Licence / residence permit", docNumber: "Document number", region: "Your region", fileHint: "Clear, readable photos. Phone photos are automatically reduced.", front: "Front side", back: "Back side", passportPage: "Page with your photo", choosePhoto: "Take or choose a photo", changePhoto: "Change photo", missingFront: "Add the photo of the front side.", missingBack: "Also add the photo of the back side.", sending: "Sending…", kycSubmit: "Send my details", kycSent: "Details saved. You can now request your withdrawal.", kycNote: "These details will be verified. At your first withdrawal, our team will contact you on WhatsApp to receive a photo of your document (front and back). No photo is requested here.", kycPendingNote: "At your first withdrawal, our team will contact you on WhatsApp to verify your document.", current: "Current limits", daily: "Deposit / day", weekly: "Deposit / week", limitHint: "You can lower a limit anytime; to raise it, ask support.", save: "Save limits", saved: "Limits saved", exclude: "Temporary self-exclusion (play and deposits blocked, cannot be undone during the period):", excludedUntil: "Self-excluded until {date}", excludeConfirm: "Block play and deposits for {days} day(s)? This cannot be undone.", days: "{n} d" },
  history: { title: "Game history", games: "Games", wins: "Wins", won: "Total won", net: "Net result", empty: "No finished games yet.", r_won: "Won", r_lost: "Lost", r_refunded: "Refunded" },
  board: { dice: "Dice", ludo: "Ludo", dames: "Draughts", title: "Leaderboard", week: "Week", month: "Month", all: "All time", wins: "{w} W / {g}", draws: "{d} D", empty: "No games in this period yet.", note: "Ranked by net result (winnings − stakes)." },
  room: { whatsapp: "Send via WhatsApp", joinTitle: "Join a private room", info: "{name}'s room · {n} players · {stake} · {w} already in", closed: "This room is no longer open.", join: "Join and stake {stake}", code: "Room code", share: "Share invitation", shareText: "Join my BKMPLAY table with code {code}", copied: "Link copied", cancel: "Cancel the room" },
  inbox: { title: "Messages", sub: "Your deposit, withdrawal and identity notices and messages from BKMPLAY. They are deleted automatically after {d} days.", empty: "No messages yet.",
    k: { announcement: "BKMPLAY announcement",
      withdraw_requested: { t: "Withdrawal request received", b: "Your withdrawal request of {a} to number …{p} is recorded. Our team will review it." },
      withdraw_approved: { t: "Withdrawal approved", b: "Your withdrawal of {a} was approved. Sending to your Mobile Money is in progress." },
      withdraw_sent: { t: "Withdrawal sent", b: "{a} were sent to your number …{p}." },
      withdraw_rejected: { t: "Withdrawal refused", b: "Your withdrawal of {a} was refused: {r}. The amount was returned to your balance." },
      withdraw_failed: { t: "Withdrawal failed", b: "Your withdrawal of {a} could not be sent. The amount was returned to your balance." },
      deposit_ok: { t: "Deposit received", b: "{a} were added to your balance. Have fun!" },
      deposit_failed: { t: "Deposit failed", b: "Your deposit of {a} did not go through. Nothing was taken from your game balance." },
      kyc_approved: { t: "Identity confirmed", b: "Your identity is confirmed. Your withdrawals can now be sent." },
      kyc_rejected: { t: "Identity refused", b: "Your identity declaration was refused: {r}. You can submit it again from My account." } } },
  ref: { title: "Referral", pitch: "Invite friends: for every staked game they finish, you get {p}% of the commission taken on their stake.", code: "Your code:", copied: "Link copied", invite: "Invite on WhatsApp", waText: "Join me on BKMPLAY (Dice, Ludo, Draughts) with my link:", filleuls: "Friends joined", active: "Active this month", month: "Earned this month", balance: "To transfer", transfer: "Transfer {a} to my balance", minTransfer: "Transfer possible from {m}", transferred: "{a} added to your balance", rules: "Read the referral rules", needKyc: "Get your identity confirmed (My account) to get your referral link.", blocked: "Your referral is suspended. Contact support.", account: "Referral account", accountSub: "Your referral earnings are kept here, separately. They can't be used to play or withdraw: you can only transfer them to your game balance." },
  chat: { title: "Game chat", placeholder: "Your message…", empty: "No messages yet. Say hello!", mute: "Hide this player", unmute: "Show hidden players", report: "Report", reportReason: "Why are you reporting this message? (optional)", reported: "Message reported to the team.",
    q_gg: "Good game!", q_luck: "Good luck!", q_nice: "Nice move!", q_oops: "Oops!", q_hurry: "Speed up?", q_thanks: "Thanks!", q_again: "Play again?", q_wow: "Wow!" },
  share: { btn: "Challenge a friend on WhatsApp", text: "I just played a free game of {game} on BKMPLAY: {result} Come and challenge me, it's free:", dice: "Dice", dames: "Draughts" },
  demo: {
    practice: "Free game (roll for each player)", practiceTitle: "Dice · free game", practiceSub: "No stake: you roll for every player, the highest total wins.", seat: "Player {n}", rollFor: "Roll for {p}", tieAgain: "Tie: {p} roll again", practiceWin: "{p} wins!",
    cardTitle: "Free discovery game",
    cardText: "Try the game for free against 3 virtual players before topping up.",
    cardCta: "Play for free",
    title: "Your free game",
    text: "You play against 3 virtual players with the same dice and rules as real games: 2 dice each, the highest total wins, tied players reroll.",
    noMoney: "Demo mode: no real money, nothing is linked to your wallet. One free game per account.",
    start: "Start the game",
    used: "You have already played your free game. Ready for a real one?",
    tableTitle: "Demo game",
    virtualPot: "Virtual pot",
    tie: "Tie! Tied players reroll",
    roll: "Roll the dice",
    rolling: "is rolling…",
    won: "Well done, you win",
    virtual: "(virtual)",
    lost: "Not this time! Now you know how it works.",
    after: "In a real game, the pot minus 15% commission goes to the winner.",
    topup: "Top up my wallet",
    realGame: "Play a real game",
    seed: "Game seed:",
    guestUsed: "You have already tried the demo game. Create your account to play for real.",
    signup: "Create my account",
    tryFree: "Try for free",
  },
  lobby: {
    overline: "Step 3",
    title: "The game table is coming soon",
    text: "Live matchmaking, queues per player count and stake, real-time rolls. Your account and wallet are already set.",
    stakes: "Planned stakes",
    players: "Players per table",
    goWallet: "Top up my wallet",
    title2: "Pick your table",
    playersLabel: "Number of players",
    stakeLabel: "Stake (XAF)",
    custom: "Or enter your stake",
    customHint: "Any amount between {min} and {max} XAF",
    pot: "Pot",
    commission: "Commission",
    gain: "Potential win",
    search: "Find players",
    waitingNow: "Waiting right now",
    noneWaiting: "Nobody is waiting yet. Start a search!",
    waitingFmt: "{n} players · {stake}",
    privateRoom: "Create a private room",
    joinCode: "Join with a code",
    soon: "Private rooms: step 4",
    balance: "Available balance",
    insufficient: "Not enough balance for this stake.",
    topup: "Top up",
    online: "{n} online",
  },
  queue: {
    title: "Finding players",
    subtitle: "{n} players · {stake}",
    counter: "{a}/{b} waiting",
    elapsed: "Waiting time",
    locked: "Stake locked",
    leave: "Leave the queue",
    promptTitle: "Still there?",
    promptText: "No full table yet. Keep waiting? Without an answer within 30 s you leave the queue and your stake is released.",
    continue: "Keep waiting",
    quit: "Leave",
    leftOk: "You left the queue. Stake released.",
    left_timeout: "Time's up: you left the queue, stake released.",
    left_disconnected: "Disconnected: you left the queue, stake released.",
    left_left: "You left the queue.",
    left_room_cancelled: "The room was cancelled by its creator. Stake released.",
  },
  game: {
    title: "Table · {n} players",
    startsIn: "Game starts in",
    finalReveal: "Final roll… result in a moment",
    waitingFor: "Waiting for {names}… The game starts as soon as they arrive (90 s max).",
    roll: "Roll",
    turnOf: "{name}'s turn",
    you: "you",
    auto: "auto",
    order: "Order of play",
    round0: "First roll",
    reroll: "Re-roll #{n} (tie)",
    winnerTitle: "You win!",
    splitTitle: "Tie: pot shared",
    lostTitle: "Game over",
    youWon: "You win {amount}",
    winnerIs: "{name} wins {amount}",
    lostText: "Your stake of {amount} is lost.",
    verify: "Verify fairness",
    again: "Play again",
    cancelled: "Game cancelled",
    cancelledText: "All stakes have been refunded.",
    settling: "Settling…",
    hash: "Hash",
    seed: "Revealed seed",
  },
  profile: {
    title: "Profile",
    memberSince: "Member since",
    birth: "Date of birth",
    kyc: "Identity check",
    kycNone: "Not verified (required before first withdrawal)",
    language: "Language",
    legal: "Legal",
  },
  legal: { terms: "Terms", rules: "Game rules", privacy: "Privacy", responsible: "Responsible gaming", back: "Back" },
  verify: {
    title: "Verify a game",
    intro: "Before each game the server publishes the SHA-256 hash of its secret seed. Once the game is over the seed is revealed: paste it here and your browser recomputes the order of play and every roll on its own (HMAC-SHA256).",
    demo: "Try with a demo game",
    gameId: "Game ID",
    seedHash: "Hash published before the game (SHA-256)",
    seed: "Revealed seed",
    players: "Player IDs (comma separated)",
    submit: "Recompute the game",
    local: "The computation runs in your browser, without the server.",
    hashOk: "The seed matches the published hash",
    hashBad: "The seed does NOT match the published hash",
    serverOk: "The recomputed result matches the server's",
    serverBad: "The recomputed result differs from the server's",
    order: "Order of play:",
    winner: "Winner:",
    hashNone: "No hash entered: the seed was not compared",
    unsupported: "Your browser cannot run this check (secure connection required).",
    round0: "First roll",
    reroll: "Re-roll #{n}",
    missing: "Fill in the game ID, the seed and at least 2 players.",
    seedHidden: "Game in progress: the seed will be revealed at the end.",
    cta: "Verify a game",
  },
  common: { loading: "Loading…", retry: "Retry", today: "Today", back: "Back" },
  errors: {
    chat_disabled: "Chat is turned off for now.", referral_below_min: "Amount too low to transfer.", referral_blocked: "Referral suspended.", rate_limited: "Too many messages, please wait a moment.", invalid_message: "Invalid message.", own_message: "You can't report your own message.",
    invalid_credentials: "Wrong identifier or password.",
    too_many_attempts: "Too many attempts. Try again in 15 minutes.",
    too_many_requests: "Too many requests. Please wait a moment.",
    must_be_adult: "You must be 18 or older.",
    must_confirm_adult_and_terms: "Please tick both confirmations.",
    email_or_phone_required: "Enter an email or a phone number.",
    invalid_email: "Invalid email address.",
    invalid_phone: "Invalid number. Format: 6XXXXXXXX or 2376XXXXXXXX.",
    unsupported_operator: "This number is neither MTN (650-654, 670-683) nor Orange (655-659, 686-699).",
    operator_mismatch: "This number doesn't match the selected operator.",
    pseudo_taken: "This username is taken.",
    invalid_ref_code: "Unknown or inactive referral code. Check it or leave the field empty.",
    email_taken: "This email is already used.",
    phone_taken: "This number is already used.",
    validation_error: "Please check the form fields.",
    amount_out_of_range: "Amount out of range.",
    campay_not_configured: "Payments are not configured yet.",
    campay_error: "The payment service rejected the request.",
    too_many_pending_payments: "You already have 3 pending payments.",
    account_suspended: "Account suspended.",
    network_error: "Cannot connect. Check your network.",
    invalid_stake: "Invalid stake (minimum 25 XAF, whole number).",
    invalid_player_count: "Invalid number of players.",
    insufficient_funds: "Not enough available balance.",
    already_in_queue: "You are already in a queue.",
    already_in_game: "You already have a game in progress.",
    opponent_unavailable: "The opponent found no longer had enough balance. Search again.",
    maintenance: "Maintenance: new games are temporarily blocked.",
    not_your_turn: "It's not your turn.",
    game_not_in_progress: "The game is not in progress.",
    stale_game_state: "Roll already done.",
    not_in_queue: "You are no longer in the queue.",
    game_not_found: "Game not found.",
    kyc_required: "Identity check required before your first withdrawal (Profile → My account).",
    self_excluded: "Self-exclusion active: play and deposits blocked.",
    deposit_daily_limit_reached: "Daily deposit limit reached.",
    deposit_weekly_limit_reached: "Weekly deposit limit reached.",
    limit_increase_needs_support: "To raise a limit, contact support.",
    kyc_already_submitted: "Document already sent.", invalid_region: "Choose your region.",
    image_too_large: "Image too large (2 MB max).",
    back_side_required: "Also add the photo of the back side.",
    wrong_current_password: "Current password is incorrect.",
    invalid_mode: "Game mode unavailable.", not_your_turn: "It is not your turn.", illegal_piece: "This piece cannot move.",
    game_not_active: "The game is over.", already_in_queue: "You are already in a queue.", conflict: "Please try again.",
    same_password: "Choose a password different from the current one.",
    unreadable_image: "Unreadable photo: choose a JPG or PNG photo.",
    invalid_image: "Invalid image (JPG, PNG or WEBP).",
    illegal_move: "Move not allowed.", invite_not_found: "Invitation not found or already used.", invite_expired: "Invitation expired.",
    invite_not_for_you: "This invitation is for another player.", cannot_invite_self: "You cannot invite yourself.",
    player_not_found: "No player with this username.", stake_not_allowed: "Stake not allowed.", not_your_turn: "Not your turn.", draw_offer_limit: "No more draw offers allowed.", room_not_found: "Room not found or closed.", waiting_players: "The game is still waiting for a player.", room_restricted: "This room is reserved for the players of the previous game.", rematch_unavailable: "A rematch is only available after a private-room game.",
    daily_withdraw_limit: "Daily withdrawal limit reached.",
    withdraw_in_progress: "A withdrawal request is already being processed, please wait a moment.",
    wager_required: "Each top-up must be staked once in a game before it can be withdrawn. {r} still to play; you can withdraw up to {w} now.",
    unknown_error: "Something went wrong.",
  },
};

export const translations = { fr, en };
